<template>
    <reservations-wrapper
        :rows="reservationsArr"
        :isLoading="isLoadingReservations"
        :hasLoadedOnce="hasLoadedOnce"
        :pageInfo="pageInfo"
        :header="header"
        :body="body"
        :paginationValue="paginationComputed"
        :resultsPerPage="resultsPerPage"
        :resultsPerPageOptions="resultsPerPageOptions"
        :initialTab="selectedTab"
        @page-change="onPageChange"
        @results-per-page-change="onResultsPerPageChange"
    >
</reservations-wrapper>
</template>

<script>
    import mixin from '@/mixins/reservationsLogicMixin'
    import List from '@/tools/list/baseList'
    import Loader from '@/tools/loaders/loader1'
    import Export from '@/tools/ExportV2'
    import SellerPicker from '@/tools/SellerPicker'
    import Multiselect from 'vue-multiselect'
    import VueDatepicker from 'vuejs-datepicker'
    import extendedVSelect from '@/extends/vue-select'
    import _ from 'lodash'
    import ReservationsTabs from '@/components/reservations/ReservationsTabs'
    import ReservationsWrapper from '@/components/reservations/ReservationsWrapper'
    import ReservationsSearchBar from '@/components/reservations/ReservationsSearchBar'
    import { RESERVATION_LIST_TYPE } from '@/enums/reservationListType'

    export default {
        name: 'ReservationsByPickupDate',
        mixins: [ mixin ],
        props: {
            reservationMainFilters: { 
                type: Object, 
                required: true 
            },
            pagination: {
                type: Object,
                default: () => ({ currentPage: 1 })
            },
            selectedTab: {
                type: String,
                default: 'reservations'
            }
        },
        data () {
            return {
                config: {
                    viewId: RESERVATION_LIST_TYPE.PICKUP_DATE,
                    listUrl: '/api/booking/TransfersList',
                    downloadUrl: '/api/booking/TransfersDownload'
                },
                hasLoadedOnce: false
            }
        },
         methods : {
            onResultsPerPageChange(newSize) {
                this.resultsPerPage = newSize;
                this.resultsPerPageChanged();
            },
             getReservationsPaginated: _.debounce(function() {
                this.selectAllReservations(false);

                 if (this.isLoadingReservations) return;

                this.isLoadingReservations = true;
                    
                axios.get(this.config.listUrl, {
                    params: this.requestFilterOptions
                }).then(response => {
                    if (response.status == 200) {
                        this.pageInfo = response.data.pageInfo;
                        this.reservationsArr = response.data.result;
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.isLoadingReservations = false;
                    this.hasLoadedOnce = true;
                });
            }, 500)
        },
        computed: {
            requestFilterOptions () {
                const reservationsFilters = this.getReservationsFilters;

                Object.assign(this.filters, {
                    resourceId: reservationsFilters.resourceId,
                    paymentStatus: reservationsFilters.paymentStatus,
                    countryId: reservationsFilters.countryId,
                    status: reservationsFilters.status,
                    currentCheckboxPickup: reservationsFilters.currentCheckboxPickup,
                    currentCheckboxNote: reservationsFilters.currentCheckboxNote,
                    categories: reservationsFilters.categories
                });

                return {
                    page: this.pagination.currentPage,
                    pageSize: this.resultsPerPage,
                    's.String': this.filters.searchString,
                    's.ProductId': this.filters.productId && this.filters.productId.length > 0 ? this.filters.productId.map(item => item.id) : null,
                    's.ResourceId': this.filters.resourceId && this.filters.resourceId.length > 0 ? this.filters.resourceId.map(item => item.id) : null,
                    's.locations': this.filters.locations && this.filters.locations.length > 0 ? this.filters.locations.map(item => item.name) : null,
                    's.audienceTypes': this.filters.categories && this.filters.categories.length > 0 ? this.filters.categories.map(item => item.name) : null,
                    's.PaymentStatus': this.filters.paymentStatus && this.filters.paymentStatus.length > 0 ? this.filters.paymentStatus.map(item => item.id) : null,
                    's.StatusList': this.filters.status && this.filters.status.length > 0 ? this.filters.status.map(item => item.id) : null,
                    's.withTransport': true,
                    's.withNote': this.filters.currentCheckboxNote ? true : null,
                    's.eventId': this.filters.eventId,
                    's.dateStart': this.reservationMainFilters.dateRange[0],
                    's.dateEnd': this.reservationMainFilters.dateRange[1],
                    's.countryId': this.filters.countryId,
                    's.sellerType': this.filters.sellerType,
                    's.channelType': this.filters.channelType,
                    's.sellerId': this.filters.sellerId
                }
            },
            header() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {
                            this.selectAllReservations(event);
                        }
                    },
                    list: {
                        productColorSign: ' ',
                        pickupDate: 'Pickup Date',
                        pickupLocation: 'Pickup',
                        seller: 'Seller',
                        hotel: 'Hotel/Room',
                        reservation: 'Reservation',
                        fullName: 'Customer',
                        created: 'Created',
                        icons: '',
                    },
                };
            },
            body() {
                return {
                    selection: {
                        active: false,
                        event: (event, reservation) => {
                            if (this.selectedReservationIds.indexOf(reservation.id) >= 0) {
                                this.selectedReservationIds.splice(this.selectedReservationIds.indexOf(reservation.id), 1);
                            } else {
                                this.selectedReservationIds.push(reservation.id);
                            }

                            this.setBulkSelectedIds(this.selectedReservationIds);
                        }
                    },
                    customRowEvent: (reservation) => {this.view(reservation.id)},
                    customCells: {
                        productColorSign: this.cellProductColorSign,
                        pickupDate: this.cellPickupDate,
                        pickupLocation: this.cellPickupLocation,
                        seller: this.cellSeller,
                        hotel: this.cellHotel,
                        reservation: this.cellReservation,
                        fullName: this.cellFullName,
                        created: this.cellCreated,
                        icons: this.cellIcons
                    }
                }
            },
        },
        components: { 
            List,
            Loader,
            Export,
            SellerPicker,
            Multiselect,
            VueDatepicker,
            vSelect: extendedVSelect,
            ReservationsTabs,
            ReservationsWrapper,
            ReservationsSearchBar
        }
    }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ReservationsByPickupDate.vue?415cdc32